export type UnityEditorPackage = {
  id: string;
  packageName: string;
  isSourceUpmRegistry?: boolean;
};

// Registry packages are opened by technical name, uploaded packages by
// package id. Falls back to the uploaded package
// link when a registry package carries no technical name.
export const buildUnityEditorUrl = ({
  id,
  packageName,
  isSourceUpmRegistry,
}: UnityEditorPackage): string =>
  isSourceUpmRegistry && packageName
    ? `com.unity3d.kharma:upmpackage/${encodeURIComponent(packageName)}`
    : `com.unity3d.kharma:content/${encodeURIComponent(id)}`;

export const openInUnityEditor = (upmPackage: UnityEditorPackage): void => {
  window.open(buildUnityEditorUrl(upmPackage), '_blank');
};
